import Image from 'next/image';
import type { TeamMatchDetailDto } from '@/api/backoffice-schemas';
import { CheckIcon as Check } from '@/components/icons/CheckIcon';
import { TeamPlaceholderIcon as TeamLogoPlaceholder } from '@/components/icons/teams/TeamPlaceholderIcon';

interface TeamDisplayProps {
  teamMatch: TeamMatchDetailDto;
  isWinner?: boolean;
  status: string;
  draw?: boolean;
}

export const TeamDisplay = ({
  teamMatch,
  isWinner = false,
  status,
  draw,
}: TeamDisplayProps) => {
  return (
    <div className="flex flex-row content-center items-center gap-2">
      {teamMatch.team?.imageUrl ? (
        <Image
          alt={teamMatch.team.name || 'Team logo'}
          height={20}
          src={teamMatch.team.imageUrl}
          width={20}
        />
      ) : (
        <TeamLogoPlaceholder
          desc="Team logo placeholder icon"
          title="Team Logo"
        />
      )}
      <div className="flex flex-row items-center gap-1 md:gap-2">
        <p className="hidden overflow-hidden text-ellipsis font-medium text-[0.875rem] leading-4.5 md:block">
          {teamMatch.team?.name || '(TBD)'}
        </p>
        <p className="font-medium text-[0.875rem] leading-4.5 md:hidden">
          {teamMatch.team?.acronym ?? teamMatch.team?.name ?? '(TBD)'}
        </p>
        {isWinner && status === 'finished' && !draw ? (
          <Check
            className="text-green"
            desc="Check mark icon for winning team"
            title="Winner"
          />
        ) : null}
      </div>
    </div>
  );
};
